<template>
    <div id="full-page" class="bg-grey-darken-4 d-flex flex-column justify-center align-center">
        <div>
            <img height="100px" src="https://cdn.visuado.com/visuado.svg" />
        </div>
        <div class="ma-10 d-md-flex justify-space-around">
            <v-btn class="ml-2" variant="outlined" rounded link href="https://www.visuado.com/">
                Homepage
            </v-btn>
            <v-btn class="ml-2" variant="outlined" rounded link href="https://visuado.com/project/">
                Our Projects
            </v-btn>
        </div>
        <div class="ma-10">
            <language-switcher></language-switcher>
        </div>
    </div>
</template>
<script setup lang="ts">
definePageMeta({
    layout: 'blank'
})
</script>
<style>
#full-page {
    width: 100%;
    position: absolute;
    height: 100vh;
}
</style>
getContext
